"use client";

import { useCallbackRef } from "radix-ui/internal";
import { useEffect } from "react";
import { useThreadViewport } from "../../context/react/ThreadViewportContext";

export const useOnScrollToBottom = (
  callback: (config: { behavior: ScrollBehavior }) => void,
) => {
  const callbackRef = useCallbackRef(callback);
  const onScrollToBottom = useThreadViewport((vp) => vp.onScrollToBottom);

  useEffect(() => {
    return onScrollToBottom(callbackRef);
  }, [onScrollToBottom, callbackRef]);
};
